import type { ProposalBatch } from "@stockline/shared/types/ai/proposal"
import { PROPOSAL_BATCH_TABLE } from "../../../lib/offline/resources/ai/proposal-batch/db"
import { useAISync } from "../providers/AISyncProvider"

export function useProposalBatch(id: string): ProposalBatch | null {
  const { reactive } = useAISync()
  return reactive.useOne<ProposalBatch>(PROPOSAL_BATCH_TABLE, id)
}
